// import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
// import AirportCityDrawer from "components/drawer/AirportDrawer";
// import MainDrawer from "components/drawer/MainDrawer";
// import DeleteModal from "components/modal/DeleteModal";
// import EditDeleteButton from "components/table/EditDeleteButton";
// import useToggleDrawer from "hooks/useToggleDrawer";
// import React from "react";

// const AirportCityTable = ({ airportcitydata, hideDelete, hideEdit }) => {
//   const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
//     useToggleDrawer();

//   return (
//     <>
//       <DeleteModal id={serviceId} title={title} />

//       <MainDrawer>
//         <AirportCityDrawer id={serviceId} />
//       </MainDrawer>

//       <TableBody>
//         {airportcitydata?.slice(0).map((data, index) => (
//           <TableRow key={data.id}>
//             <TableCell className="text-center text-xs">{index + 1}</TableCell>

//             <TableCell className="text-center text-xs">
//               {data.airportname}
//             </TableCell>
//             <TableCell className="text-center text-xs">
//               {data.airportcode}
//             </TableCell>
//             <TableCell className="text-center text-xs">
//               {data.city_name}
//             </TableCell>
//             <TableCell className="text-center text-xs">
//               {data.parking}
//             </TableCell>

//             <TableCell>
//               <div className="flex justify-center">
//                 <EditDeleteButton
//                   id={data.id}
//                   isSubmitting={isSubmitting}
//                   handleUpdate={handleUpdate}
//                   handleModalOpen={handleModalOpen}
//                   hideDelete={hideDelete}
//                   hideEdit={hideEdit}
//                 />
//               </div>
//             </TableCell>
//           </TableRow>
//         ))}
//       </TableBody>
//     </>
//   );
// };

// export default AirportCityTable;

import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import AirportDrawer from "components/drawer/AirportDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState } from "react";
import { FiEye } from "react-icons/fi";

const AirportCityTable = ({ airportcitydata, hideDelete, hideEdit }) => {
  const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
    useToggleDrawer();

  const [showParkingModal, setShowParkingModal] = useState(false);
  const [selectedParking, setSelectedParking] = useState({});

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      {/* <MainDrawer>
        <AirportCityDrawer id={serviceId} />
      </MainDrawer> */}

      <MainDrawer>
        <AirportDrawer key={serviceId ?? "new"} id={serviceId} />
      </MainDrawer>

      <TableBody>
        {airportcitydata?.slice(0).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>

            <TableCell className="text-center text-xs">
              {data.airportname || "-"}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.airportcode || "-"}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.city_name || "-"}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.latitude || "-"}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.longitude || "-"}
            </TableCell>

            {/* <TableCell className="text-center text-xs">
              {data.parking}
            </TableCell> */}
            <TableCell className="text-center">
              <button
                type="button"
                onClick={() => {
                  setSelectedParking(data.parking_details || {});
                  setShowParkingModal(true);
                }}
                className="inline-flex items-center justify-center w-8 h-8 rounded-full transition"
              >
                <FiEye size={18} />
              </button>
            </TableCell>
            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  id={data.id}
                  isSubmitting={isSubmitting}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideDelete={hideDelete}
                  hideEdit={hideEdit}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      {showParkingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 overflow-hidden">
            <div className="flex justify-between items-center px-5 py-4 border-b">
              <h2 className="text-lg font-semibold">Vehicle Parking Fees</h2>

              <button
                onClick={() => setShowParkingModal(false)}
                className="text-gray-500 hover:text-red-500 text-xl"
              >
                ✕
              </button>
            </div>

            <div className="p-5">
              <table className="w-full border rounded-lg overflow-hidden">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="text-left px-4 py-2">Vehicle</th>
                    <th className="text-right px-4 py-2">Parking Fee</th>
                  </tr>
                </thead>

                <tbody>
                  {Object.values(selectedParking).map((vehicle, index) => (
                    <tr key={index} className="border-t">
                      <td className="px-4 py-3">{vehicle.name}</td>

                      <td className="px-4 py-3 text-right font-semibold text-green-600">
                        ₹ {vehicle.fee}
                      </td>
                    </tr>
                  ))}

                  {Object.keys(selectedParking).length === 0 && (
                    <tr>
                      <td
                        colSpan={2}
                        className="text-center py-5 text-gray-500"
                      >
                        No parking data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AirportCityTable;
